import { tokens } from "@/tokens";
import React from "react";
import {
  Box,
  Button,
  Collapse,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import {
  CheckCircle as ConfirmIcon,
  DoNotDisturb as DismissIcon,
  EditNote as AdjustIcon,
  Close as ClearIcon,
} from "@mui/icons-material";

interface VerificationToolbarProps {
  selectedCount: number;
  onClear: () => void;
  onMarkConfirmed: () => void;
  onMarkNotAnIssue: () => void;
  onCreateAdjustment: () => void;
}

const VerificationToolbar: React.FC<VerificationToolbarProps> = ({
  selectedCount,
  onClear,
  onMarkConfirmed,
  onMarkNotAnIssue,
  onCreateAdjustment,
}) => {
  return (
    <Collapse in={selectedCount > 0} unmountOnExit>
      <Box sx={{ px: 3, pb: 1 }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          sx={{
            p: 1.5,
            bgcolor: tokens.status.successBg,
            border: "1px solid #99F6E4",
            borderRadius: tokens.radius.md,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: tokens.fontWeight.bold, color: tokens.brand.primary, minWidth: 80 }}
          >
            {selectedCount} selected
          </Typography>
          <Button
            size="small"
            startIcon={<ClearIcon sx={{ fontSize: 14 }} />}
            onClick={onClear}
            sx={{
              color: tokens.text.secondary,
              fontSize: tokens.fontSize.md,
            }}
          >
            Clear
          </Button>
          <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
          <Button
            size="small"
            variant="outlined"
            startIcon={<ConfirmIcon sx={{ fontSize: 16 }} />}
            onClick={onMarkConfirmed}
            sx={{
              fontWeight: tokens.fontWeight.bold,
              fontSize: tokens.fontSize.md,
              borderColor: tokens.status.danger,
              color: tokens.status.danger,
              "&:hover": { borderColor: tokens.status.dangerHover, bgcolor: tokens.status.dangerBg },
            }}
          >
            Mark Confirmed
          </Button>
          <Button
            size="small"
            variant="outlined"
            startIcon={<DismissIcon sx={{ fontSize: 16 }} />}
            onClick={onMarkNotAnIssue}
            sx={{
              fontWeight: tokens.fontWeight.bold,
              fontSize: tokens.fontSize.md,
              borderColor: tokens.status.success,
              color: tokens.status.success,
              "&:hover": { borderColor: tokens.chip.green.text, bgcolor: tokens.status.successBg },
            }}
          >
            Mark Not an Issue
          </Button>
          <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
          <Button
            size="small"
            variant="contained"
            startIcon={<AdjustIcon sx={{ fontSize: 16 }} />}
            onClick={onCreateAdjustment}
            sx={{
              fontWeight: tokens.fontWeight.bold,
              fontSize: tokens.fontSize.md,
              bgcolor: tokens.brand.primary,
              "&:hover": { bgcolor: tokens.brand.primaryHover },
            }}
          >
            Create Adjustment
          </Button>
        </Stack>
      </Box>
    </Collapse>
  );
};

export default VerificationToolbar;
